import * as Sentry from '@sentry/browser';
import { takeEvery, call, put } from 'redux-saga/effects';
import { fetchDashboard } from '../../actions/DashboardActions';
import { RENAME_SEGMENT, renameSegmentSuccess, renameSegmentError, RenameSegment } from '../../actions/DeviceActions';
import { renameSegment } from '../../api/segment';
import { ErrorType } from '../../models/commonTypeScript';

export const writeToSentry = (error: ErrorType): void => {
    if (Sentry) {
        Sentry.captureException(error);
    }
};

export function* renameSegmentSaga({ payload }: RenameSegment): Generator {
    try {
        yield call(renameSegment, payload);
        yield put(renameSegmentSuccess(payload));
        yield put(fetchDashboard());
    } catch (error) {
        yield put(renameSegmentError(error));
        yield call(writeToSentry, error);
    }
}

export default function* RenameSegmentSaga(): Generator {
    yield takeEvery(RENAME_SEGMENT, renameSegmentSaga);
}
